import React from "react";

export default function NotesList({ notes, loading }) {
  if (loading) return <Skeleton />;
  if (!notes.length)
    return (
      <div style={s.empty}>
        <span style={{ fontSize: 40, display: "block", marginBottom: 10 }}>📭</span>
        Select a subject to see notes
      </div>
    );

  return (
    <div>
      <div style={s.sectionTitle}>📄 Notes & Study Material</div>
      <div style={s.list}>
        {notes.map((note) => (
          <div key={note.id} style={s.card}>
            <div style={s.left}>
              <div style={s.pdfBadge}>PDF</div>
              <div style={s.meta}>
                <div style={s.title}>{note.title}</div>
                <div style={s.desc}>{note.description}</div>
                <div style={s.info}>
                  <span style={s.sizeBadge}>{note.fileSize}</span>
                  <span style={s.dot}>·</span>
                  <span style={s.date}>
                    {new Date(note.uploadedAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                  </span>
                </div>
              </div>
            </div>
            <a
                    href={`https://learnwithpayal-backend-production.up.railway.app/api/v1/notes/${note.id}/download`}
              download
              style={s.dlBtn}
              target="_blank"
              rel="noreferrer"
            >
              ⬇ Download
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

function Skeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {[1, 2, 3].map((i) => (
        <div key={i} style={{ ...s.card, opacity: 0.4, pointerEvents: "none" }}>
          <div style={{ width: 36, height: 36, background: "#334155", borderRadius: 8 }} />
          <div style={{ flex: 1 }}>
            <div style={sk(180, 14)} />
            <div style={{ ...sk(130, 11), marginTop: 7 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

const sk = (w, h) => ({
  width: w, height: h, borderRadius: 6,
  background: "#334155",
  animation: "shimmer 1.5s infinite",
  backgroundImage: "linear-gradient(90deg,#1e293b 25%,#334155 50%,#1e293b 75%)",
  backgroundSize: "400% 100%",
});

const s = {
  sectionTitle: { fontSize: 15, fontWeight: 600, color: "#e2e8f0", fontFamily: "'Sora',sans-serif", marginBottom: 14 },
  list: { display: "flex", flexDirection: "column", gap: 10 },
  card: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    background: "#1e293b", border: "1px solid #334155", borderRadius: 12,
    padding: "14px 16px", gap: 12, flexWrap: "wrap",
  },
  left: { display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 0 },
  pdfBadge: { background: "#ef4444", color: "#fff", fontSize: 9, fontWeight: 800, borderRadius: 6, padding: "5px 7px", fontFamily: "monospace", flexShrink: 0 },
  meta: { flex: 1, minWidth: 0 },
  title: { fontSize: 14, fontWeight: 600, color: "#f1f5f9", fontFamily: "'Sora',sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  desc: { fontSize: 12, color: "#64748b", fontFamily: "'Sora',sans-serif", marginTop: 2 },
  info: { display: "flex", alignItems: "center", gap: 6, marginTop: 5 },
  sizeBadge: { fontSize: 10, background: "#0f172a", color: "#64748b", borderRadius: 4, padding: "2px 6px", fontFamily: "monospace" },
  dot: { color: "#334155" },
  date: { fontSize: 11, color: "#475569", fontFamily: "'Sora',sans-serif" },
  dlBtn: { background: "#3b82f6", color: "#fff", border: "none", borderRadius: 9, padding: "9px 18px", fontSize: 12, fontWeight: 600, cursor: "pointer", textDecoration: "none", whiteSpace: "nowrap", fontFamily: "'Sora',sans-serif", flexShrink: 0 },
  empty: { textAlign: "center", color: "#475569", fontSize: 15, padding: "60px 0", fontFamily: "'Sora',sans-serif" },
};
